import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './stores/index';
import 'bootstrap';
import BootstrapVue from 'bootstrap-vue';
// @ts-ignore -- No types are provided for this lib
import bFormSlider from 'vue-bootstrap-slider';
import VueApexCharts from 'vue-apexcharts';
import VueMoment from 'vue-moment';
import * as moment from 'moment-timezone';
import {CurrencyFilter} from '@/filters/currency';
import LoadingIndicator from '@/components/LoadingIndicator.vue';
import {library} from '@fortawesome/fontawesome-svg-core';
import {faFileInvoiceDollar, faFilePdf} from '@fortawesome/pro-light-svg-icons';
import {faCaretRight, faCaretLeft} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';

library.add(faFileInvoiceDollar);
library.add(faCaretRight);
library.add(faCaretLeft);
library.add(faFilePdf);

Vue.use(VueMoment, {
	moment: moment,
});
Vue.filter('currency', CurrencyFilter);
Vue.use(VueApexCharts);
Vue.use(bFormSlider);
Vue.use(BootstrapVue);
Vue.component('LoadingIndicator', LoadingIndicator);
Vue.component('fa-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount('#app');
